import { useContext } from "react";
import { EntityKeyContext } from "./EntityKeyContext.js";
const useHasEntity = () => {
  return useContext(EntityKeyContext) !== void 0;
};
export {
  useHasEntity
};
//# sourceMappingURL=useHasEntity.js.map
